import React from "react";
import { Box } from "@mui/material";
import CurrentApplications from "my-tax/components/current-applications";

interface MyTaxApplicationWrapperProps {
  label: string;
}

const MyTaxApplicationWrapper: React.FC<MyTaxApplicationWrapperProps> = ({
  label,
}) => {
  return (
    <>
      <Box height="16px" />
      <CurrentApplications label={label} />
      <Box height="16px" />
    </>
  );
};

export default MyTaxApplicationWrapper;
